import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const LEVELS = [
  { key: "region", label: "Région" },
  { key: "prefecture", label: "Préfecture" },
  { key: "commune", label: "Commune" },
  { key: "canton", label: "Canton" },
  { key: "localite", label: "Localité" },
];

export const LocationCascade = ({ value = {}, onChange, layout = "grid" }) => {
  const [opts, setOpts] = useState({});

  const load = useCallback((level, filters) => {
    const qs = new URLSearchParams({ level });
    Object.entries(filters).forEach(([k, v]) => v && qs.set(k, v));
    api.get(`/localisations?${qs.toString()}`).then((r) => setOpts((o) => ({ ...o, [level]: r.data }))).catch(() => {});
  }, []);

  useEffect(() => { load("region", {}); }, [load]);

  // preload child options when values are prefilled (edit mode)
  useEffect(() => {
    LEVELS.forEach((l, i) => {
      if (i > 0 && value[LEVELS[i - 1].key]) {
        const filters = {};
        for (let j = 0; j < i; j++) filters[LEVELS[j].key] = value[LEVELS[j].key];
        load(l.key, filters);
      }
    });
    // eslint-disable-line
  }, []); // once on mount

  const pick = (level, v) => {
    const idx = LEVELS.findIndex((l) => l.key === level);
    const next = { ...value, [level]: v };
    for (let i = idx + 1; i < LEVELS.length; i++) next[LEVELS[i].key] = "";
    onChange(next);
    if (idx + 1 < LEVELS.length) {
      const filters = {};
      for (let i = 0; i <= idx; i++) filters[LEVELS[i].key] = next[LEVELS[i].key];
      load(LEVELS[idx + 1].key, filters);
    }
  };

  const cls = layout === "row" ? "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2" : "grid grid-cols-1 sm:grid-cols-2 gap-3";

  return (
    <div className={cls}>
      {LEVELS.map((l, i) => {
        const disabled = i > 0 && !value[LEVELS[i - 1].key];
        return (
          <Select key={l.key} value={value[l.key] || ""} onValueChange={(v) => pick(l.key, v)} disabled={disabled}>
            <SelectTrigger data-testid={`loc-${l.key}`} className="h-10"><SelectValue placeholder={l.label} /></SelectTrigger>
            <SelectContent className="max-h-72">
              {(opts[l.key] || []).map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
            </SelectContent>
          </Select>
        );
      })}
    </div>
  );
};
